import { useTranslation } from "gatsby-plugin-react-i18next";
import type { FC } from "react";
import BreadcrumbsComponent from "../../components/Breadcrumbs";
import BreadcrumbItem from "../../components/Breadcrumbs/components/Breadcrumb/Breadcrumb";
import Icon from "../../components/general/Icon";
import Link from "../../components/general/Link";
import type { Breadcrumb } from "../../utils/breadcrumbs";

type BreadcrumbsProps = {
	breadcrumbs?: Breadcrumb[];
};

export const Breadcrumbs: FC<BreadcrumbsProps> = ({ breadcrumbs }) => {
	const { t } = useTranslation();
	const breadcrumbItems = breadcrumbs?.map((breadcrumb, index) => (
		<BreadcrumbItem
			key={index}
			label={breadcrumb.label}
			href={breadcrumb.link}
			isActive={index === breadcrumbs.length - 1}
			hasSeparator={!!index}
			position={index + 1 + ""}
		/>
	));
	if (breadcrumbItems) {
		return (
			<BreadcrumbsComponent>
				<li
					itemProp="itemListElement"
					itemScope
					itemType="https://schema.org/ListItem"
				>
					<Link href="/" aria-label={t("Back home")}>
						<Icon icon="dots-three" />
					</Link>
					<meta itemProp="name" content={t("Back home")}></meta>
				</li>
				{breadcrumbItems}
			</BreadcrumbsComponent>
		);
	}
	return null;
};
